import React, { Component } from 'react';
import type { ComponentProps } from 'react';
import styled from 'styled-components';
import { FjAvatar } from 'components/primitives';

const Container = styled.div`
  position: relative;
`;

interface FjAvatarMenuProps {
  authenticated?: boolean;
  initials?: React.ReactNode;
  fjAvatarStyle?: React.CSSProperties;
  renderMenu: (args: { onClose: () => void }) => React.ReactNode;
}

interface FjAvatarMenuState {
  showAvatarMenu: boolean;
}

class FjAvatarMenu extends Component<FjAvatarMenuProps, FjAvatarMenuState> {
  static defaultProps = {
    fjAvatarStyle: {},
  };

  state: FjAvatarMenuState = {
    showAvatarMenu: false,
  };

  menu = React.createRef<HTMLDivElement>();

  componentDidMount(): void {
    window.addEventListener('click', this.handleDocumentClick);
  }

  componentWillUnmount(): void {
    window.removeEventListener('click', this.handleDocumentClick);
  }

  closeMenu = (): void => {
    this.setState({
      showAvatarMenu: false,
    });
  };

  handleDocumentClick = (event: MouseEvent): void => {
    if (!this.menu.current!.contains(event.target as Node)) {
      this.closeMenu();
    }
  };

  handleAvatarClick = (): void => {
    this.setState((prevState) => {
      return {
        showAvatarMenu: !prevState.showAvatarMenu,
      };
    });
  };

  render(): React.ReactNode {
    const { authenticated, initials, fjAvatarStyle, renderMenu } = this.props;
    const { showAvatarMenu } = this.state;

    if (authenticated) {
      return (
        <Container ref={this.menu}>
          <FjAvatar
            boxSize={30}
            onClick={this.handleAvatarClick}
            initials={initials}
            fjAvatarStyle={fjAvatarStyle as ComponentProps<typeof FjAvatar>['fjAvatarStyle']}
            selectable
          />
          {showAvatarMenu && renderMenu({ onClose: this.closeMenu })}
        </Container>
      );
    }

    return null;
  }
}

export default FjAvatarMenu;
